<template>
<div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
  <div class="content">
    <div class="skt" ref="skt" style="margin-top:0px">
      <div class="select">
        <span class="xzqh">堤防名称:</span>
        <div class="selcountry">
          <el-input v-model="query.searchName" clearable @change="Global.emptyQuery(query.searchName,searchTheData)" placeholder="请输入"></el-input>
        </div>

        <span id="search" @click="searchTheData">查询</span>
        <span v-if="allowsPerm.delete" id="del" @click="delDialog"><span class="del-icon"></span>删除</span>
        <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
        <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>

      </div>
      <div class="tablebox">
        <div class="fzxxtable">
          <el-table :row-class-name="tableRowClassName" ref="multipleTable" @row-click="clickRow" v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
            <el-table-column type="selection" min-width="40" align="center">
            </el-table-column>
            <el-table-column type="index" width="60" label="序号"
                             align="center" header-align="center"
                             :index='(index)=>{return (index+1) + (pageIndex-1)*pageSize }'>
            </el-table-column>
            <el-table-column prop="dikeName" label="堤防名称" min-width="210">
            </el-table-column>
            <el-table-column prop="adcdnm" label="乡镇" min-width="170">
            </el-table-column>
            <el-table-column prop="rvcd" label="所在河流" min-width="150">
            </el-table-column>
            <el-table-column prop="dikePattern" label="堤防型式" min-width="130">
            </el-table-column>
            <el-table-column prop="dikeLevel" label="堤防级别" min-width="130">
            </el-table-column>
            <el-table-column align="right" prop="dikeLength" label="长度" min-width="100">
            </el-table-column>
            <el-table-column align="right" prop="floodStandard" label="规划防洪标准" min-width="130">
            </el-table-column>
            <el-table-column prop="riverBank" label="河流岸别" min-width="170">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <pager
          @current-change="onCurrentChange"
          @size-change="onSizeChange"
          :pageIndex="pageIndex"
          :pageSize="pageSize"
          :total="total"
      ></pager>
    </div>
  </div>
  <el-dialog class="abow_dialog" :title="status + '(海塘)堤防信息'" :visible.sync="addbtn" :close-on-click-modal="false">
    <el-form ref="groupForm" :model="form" :rules="rules" label-width="170px" label-height="40px">
      <el-form-item label="堤防名称:" prop="dikeName">
        <el-input v-model="form.dikeName"></el-input>
      </el-form-item>
      <el-form-item label="乡镇:" prop="adcdid">
        <el-select v-model="form.adcdid" filterable clearable placeholder="请选择乡镇">
          <el-option v-for="item in adcds" :key="item.adcd" :label="item.adnm" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在河流:" prop="rvcd">
        <el-input v-model="form.rvcd"></el-input>
      </el-form-item>
      <el-form-item label="所属小流域:" prop="cacd">
        <el-select v-model="form.cacd" filterable clearable placeholder="请选择">
          <el-option v-for="item in cacds" :key="item.cacd" :label="item.canm" :value="item.cacd">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="河流岸别:" prop="riverBank">
        <el-input v-model="form.riverBank"></el-input>
      </el-form-item>
      <el-form-item label="堤防跨界情况:" prop="crossBorder">
        <el-input v-model="form.crossBorder"></el-input>
      </el-form-item>
      <el-form-item label="堤防类型:" prop="dikeType">
        <el-input v-model="form.dikeType"></el-input>
      </el-form-item>
      <el-form-item label="堤防型式:" prop="dikePattern">
        <el-input v-model="form.dikePattern"></el-input>
      </el-form-item>
      <el-form-item label="堤防级别:" prop="dikeLevel">
        <el-input v-model="form.dikeLevel"></el-input>
      </el-form-item>
      <el-form-item label="规划防洪标准:" prop="floodStandard">
        <el-input v-model="form.floodStandard"></el-input>
      </el-form-item>
      <el-form-item label="堤防长度:" prop="dikeLength">
        <el-input v-model="form.dikeLength"></el-input>
        <label>(m)</label>
      </el-form-item>
      <el-form-item label="高程系统:" prop="elevationSystem">
        <el-input v-model="form.elevationSystem"></el-input>
      </el-form-item>
      <el-form-item label="设计水(高潮)位:" prop="designWaterLevel">
        <el-input v-model="form.designWaterLevel"></el-input>
        <label>(m)</label>
      </el-form-item>
      <el-form-item label="堤防高度(最大):" prop="dikeMaxHeight">
        <el-input v-model="form.dikeMaxHeight"></el-input>
        <label>(m)</label>
      </el-form-item>
      <el-form-item label="堤防高度(最小):" prop="dikeMinHeight">
        <el-input v-model="form.dikeMinHeight"></el-input>
        <label>(m)</label>
      </el-form-item>
      <el-form-item label="堤顶宽度(最大):" prop="dikeMaxWidth">
        <el-input v-model="form.dikeMaxWidth"></el-input>
        <label>(m)</label>
      </el-form-item>
      <el-form-item label="堤顶宽度(最小):" prop="dikeMinWidth">
        <el-input v-model="form.dikeMinWidth"></el-input>
        <label>(m)</label>
      </el-form-item>
      <el-form-item label="工程任务:" prop="engineeringTasks">
        <el-input v-model="form.engineeringTasks"></el-input>
      </el-form-item>
      <el-form-item label="堤顶高程(起点):" prop="leveeElevationBeg">
        <el-input v-model="form.leveeElevationBeg"></el-input>
        <label>(m)</label>
      </el-form-item>
      <el-form-item label="堤顶高程(终点):" prop="leveeElevationEnd">
        <el-input v-model="form.leveeElevationEnd"></el-input>
        <label>(m)</label>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="addbtn = false">取 消</el-button>
      <el-button type="primary" @click="onGroupSave">保 存</el-button>
    </span>
  </el-dialog>
</div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import monitorTypes from '@/store/types/monitor'
import baseTypes from '@/store/types/base'
import Pager from '@/components/Pager'
export default {
  components: {
    Pager
  },
  props: ['addvcd'],
  name: 'Scence',
  data () {
    return {
      query: {
        adcdA: []
      },
      cacds: [],
      dikename: '',
      loading: true,
      aDCD: '330324',
      aDDVCD: '',
      cACD: '',
      height: 100,
      catalogs: [{
        name: '1级堤防',
        value: 'Level1'
      },
      {
        name: '2级堤防',
        value: 'Level2'
      },
      {
        name: '3级堤防',
        value: 'Level3'
      },
      {
        name: '4级堤防',
        value: 'Level4'
      },
      {
        name: '5级堤防',
        value: 'Level5'
      }
      ],
      form: {
        name: ''
      },
      addbtn: false,
      adcdval: [],
      adcds: [],
      cscds: [],
      checkarr: [],
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      tdata: [],
      isTown: true,
      searchName: '',
      mutiRanksAdcd: [],
      delId: [],
      all: true,
      multipleSelection: [],
      status: '新增',
      cPageIndex: '1',
      cPageSize: '100',
      rules: {
        adcdid: [{
          required: true,
          message: '请选择乡镇',
          trigger: 'change'
        }],
        cacd: [{
          required: true,
          message: '请选择所属小流域',
          trigger: 'change'
        }],
        dikeName: [{
          required: true,
          message: '堤防名称不能为空',
          trigger: 'blur'
        }],
        rvcd: [{
          required: true,
          message: '所在河流不能为空',
          trigger: 'blur'
        }],
        dikeType: [{
          required: true,
          message: '堤防类型不能为空',
          trigger: 'blur'
        }],
        dikeLevel: [{
          required: true,
          message: '堤防级别不能为空',
          trigger: 'blur'
        }],
        dikeLength: [{
          required: true,
          message: '堤防长度不能为空'
        },
        {
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }
        ],
        designWaterLevel: [{
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }],
        dikeMaxHeight: [{
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }],
        dikeMinHeight: [{
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }],
        dikeMaxWidth: [{
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }],
        dikeMinWidth: [{
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }],
        leveeElevationBeg: [{
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }],
        leveeElevationEnd: [{
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }],
        damHeight: [{
          required: true,
          message: '坝高不能为空'
        },
        {
          validator: this.Global.checkNumeral,
          trigger: 'blur'
        }
        ]
      }
    }
  },
  watch: {
    addvcd (val, oldVal) { // 普通的watch监听
      this.loading = true
      this.pageIndex = 1 // 重置页码
      this.aDDVCD = val
      this.thedata()
    }
  },
  methods: {
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    searchTheData () {
      this.pageIndex = 1 // 重置页码
      this.thedata()
    },
    tableRowClassName ({
      row,
      rowIndex
    }) {
      if (rowIndex % 2 !== 0) {
        return 'warning-row-change'
      }
      return ''
    },
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_DIKE, {
        aDCD: this.aDDVCD,
        cACD: this.cACD,
        searchName: this.query.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.tdata = data.results
        this.total = data.total
        this.loading = false
      })
    },
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    formatCatalog (row) {
      let value = row.dikeTypeCatalog
      let returnValue = ''
      if (value !== '' && value !== undefined) {
        let option = this.catalogs.find(item => {
          return item.value === value
        })
        returnValue = option.name
      }
      return returnValue
    },
    buildTimeFormat (row) {
      let buildTime = ''
      if (row.buildYear !== '' && row.buildYear !== undefined) {
        buildTime += row.buildYear + '年'
      }
      if (row.buildMonth !== '' && row.buildMonth !== undefined) {
        buildTime += row.buildMonth + '月'
      }
      return buildTime
    },
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.form = {}
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      this.status = '编辑'
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.addbtn = true
        this.form = Object.assign({}, this.multipleSelection[0])
        this.Global.clearValidate(this, 'groupForm')
      }
    },
    // 删除
    delDialog () {
      if (this.multipleSelection.length < 1) {
        this.$alert('必需选择一条信息', '提示')
      } else {
        let ids = []
        this.multipleSelection.forEach(function (item) {
          ids.push(item.id)
        })
        this.$confirm(`确定要删除已选择的堤防(海塘)信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_DIKE, { id: ids.join(',') }).then(() => {
            this.multipleSelection = []
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
            this.loading = false
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },

    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(scenceTypes.SAVE_DIKE, this.form).then(() => {
            this.loading = false
            this.addbtn = false
            this.$notify.success({
              title: '成功',
              message: '保存成功。'
            })
            this.thedata()
            this.form = {}
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    getCacd () {
      this.$store.dispatch(baseTypes.GET_CACD, {
        pageIndex: this.cPageIndex,
        pageSize: this.cPageSize
      }).then(data => {
        this.cacds = data.results
      }).catch(() => {})
    },
    // 获取乡镇
    adcddata () {
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.results.length
        this.adcds = data.results
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', {
          name: this.$route.meta,
          type: this.$route.name
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', {
      name: this.$route.meta,
      type: this.$route.name
    })
  },
  mounted () {
    this.getMutiRanksAdcd()
    this.thedata()
    this.adcddata()
    this.getCacd()
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
 <style scoped >
.scence .content{
  padding: 0!important;
}
.scence .skt{
  height: calc(100% - 139px);
}
.scence >>>.el-form-item__content{
  width: 65%!important;
}
.countryList {
    height: 62px;
    background-color: #ffffff;
    border-radius: 5px;
    color: #444444;
    font-size: 15px;
    margin-top: 15px;
}
.country {
    float: left;
    font-family: Microsoft YaHei UI;
    font-size: 15px;
    text-align: center;
    margin-top: 20px;
    margin-left: 0.5%;
    cursor: pointer;
}
.countryon {
    border-radius: 15px;
    background-color: #fda72c;
    color: #ffffff;
}
.country span {
    padding: 4px 15px;
}
.scence >>> .el-dialog__body {
    height: 70%;
    left: 0;
    top: 54px;
    bottom: 0;
    right: 0;
    z-index: 1;
    overflow: hidden;
    overflow-y: auto;
}
.scence >>> .el-dialog {
    margin: 0 auto !important;
}
.scence >>> .el-form-item {
    margin-left: 1%;
    width: 44% !important;
}
.scence >>> .el-dialog__footer {
    margin-top: 20px;
}
.dikecontet {
    width: 96%;
    float: left;
    border: 2px solid #EFF1F5;
    height: 150px;
    margin-left: 2%;
    margin-top: 20px;
}
.dikecontet:hover {
    border: 2px solid #3d6ffb;
}
.dikepic {
    float: left;
    width: 300px;
    height: 140px;
    margin-left: 3px;
    margin-top: 3px;
}
.dike {
    float: left;
    width: 1450px;
    height: 140px;
    margin-left: 10px;
    margin-top: 3px;
}
.dikeform {
    height: 140px;
    margin-left: 10px;
    margin-top: 3px;
    float: left;
}
.dikespan {
    width: 100%;
    float: left;
    line-height: 35px;
    font-size: 16px;
}
.scence >>> .num {
    font-weight: 700;
    color: #606266;
    margin-left: 5px;
}
.scence >>> .content1 {
    width: 300px;
    margin-left: 60px;
}
.scence >>> .content2 {
    margin-left: 90px;
    width: 260px;
}
.skt{
  margin-top: 15px!important;
}
</style>
